import React from 'react';
import NavBar from './NavBar';

interface DefaultLayoutProps {
  children: React.ReactNode;
}

export default function DefaultLayout({ children }: DefaultLayoutProps) {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <NavBar />
      <main className="pt-24">
        {children}
      </main>
    </div>
  );
} 